<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Seguimiento de Proyectos</li>
            </ol>
        </nav>

        <div class="container-fluid">
            <!-- FILTROS -->
            <div class="row">
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <h1 class="bold big-title m-0">Seguimiento de <span>proyectos</span>.</h1>
                    </vx-card>
                </div>
                <!-- FILTROS -->
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <h4 class="bold">Buscar proyecto</h4>
                        <vs-row vs-justify="center">
                            <vs-col vs-justify="left" vs-align="left" vs-w="11">
                                <vs-input size="large" color="warning" style="width: 100%" label-placeholder="Criterios de búsqueda: PID, ALIAS" v-model="search" v-on:keyup.enter="getProjectsList()"/>
                            </vs-col>
                            <vs-col vs-justify="center" vs-align="center" vs-w="1">
                                <vs-button size="large" style="margin-left: 35%; margin-top: 15%;" color="warning" type="filled" icon="search" v-on:click="getProjectsList()" :disabled="searching"></vs-button>
                            </vs-col>
                        </vs-row>
                    </vx-card>
                </div>
                <!-- TABLE -->
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <vs-table style="z-index: 5 !important;" stripe max-items="15" pagination search :data="projects" noDataText="No hay datos disponibles">
                            <div slot="header">
                                <h4>Lista de proyectos</h4>
                            </div>
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].PID">
                                    <router-link :to="`/project/${tr.PID}`" target="_blank">
                                        {{tr.PID}} | {{tr.alias}}
                                    </router-link>
                                    </vs-td>
                                    <vs-td>
                                        <vs-chip transparent color="primary">
                                            {{tr.status}}
                                        </vs-chip>
                                    </vs-td>
                                    <vs-td>
                                        <strong>{{tr.client.name}}</strong>
                                        <br> {{tr.client.email}}
                                        <br> {{(tr.client.phone ? `${tr.client.phone.country_calling_code} ${phoneFormat(tr.client.phone.phone)}` : '--')}}
                                        <div class="clickable" v-if="tr.potential_applicant != null" @click.stop="currentLead = tr.potential_applicant, popupActivoProgram = true">
                                            <vs-chip color="#f44336">
                                                <strong>{{ tr.potential_applicant.program_info.name }}</strong>
                                            </vs-chip>
                                        </div>  
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.origination_responsible || '--' }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.credit_risk_responsible || '--' }}
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="tr.supplier != null">
                                            <strong>{{tr.supplier.tradename}}</strong>
                                            <br> {{tr.supplier.email}}
                                            <br> SID: {{tr.supplier.id}}
                                            <br>
                                            <div class="clickable" @click="showSupplierInformation(tr.supplier.id)">
                                                <vs-chip transparent color="warning">
                                                    <span class="bold text-xs">Ver informacion del proveedor</span>
                                                </vs-chip>
                                            </div>
                                            <supplier-agent-information :projectId="tr.PID"></supplier-agent-information>
                                        </template>
                                        <div v-else>
                                            <p>Sin proveedor</p>
                                        </div>
                                    </vs-td>
                                    <vs-td class="text-center">
                                        <vs-chip transparent color="dark">
                                            <span class="bold text-xs">{{tr.returned_count}}</span>
                                        </vs-chip>
                                    </vs-td>
                                    <vs-td class="text-center">
                                        <vs-chip transparent color="dark">
                                            <span class="bold text-xs">{{tr.days_passed}}</span>
                                        </vs-chip>
                                    </vs-td>
                                    <vs-td>
                                        <div class="row">
                                            <div class="col-sm-6 col-md-6 col-lg-4 ml-2 mt-1"> 
                                                <vs-button size="small" color="primary" type="filled" icon="announcement" @click="showProjectMessages(tr.PID)">Bitácora</vs-button>
                                            </div>
                                            <div class="col-sm-6 col-md-6 col-lg-4 ml-2 mt-1"> 
                                                <vs-button size="small" color="warning" type="filled" icon="assignment" @click="showCreditEvents(tr.PID)">Eventos</vs-button>
                                            </div>
                                            <div class="col-sm-6 col-md-6 col-lg-2 ml-2 mt-1"> 
                                                <project-archive-button :project="setProjectInformation(tr)"></project-archive-button>
                                            </div>
                                            <div class="col-sm-6 col-md-6 col-lg-8 ml-2 mt-1"> 
                                                <LoanScreenedButton :loanId="tr.PID" :isScreened="true" @on-save="getProjectsList"></LoanScreenedButton>
                                            </div>
                                        </div>  
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
            </div>
        </div>

        <!-- CREDIT EVENTS -->
        <vs-popup title="Eventos de la solicitud" :active.sync="showFormPromptCreditEvents">
            <credit-events-log ref="creditEvents" class="mt-4" :projectId="currentProjectId" />
        </vs-popup>

        <!-- MESSAGES -->
        <vs-popup title="Mensajero" :active.sync="showFormPromptMessages">
            <project-message-logger ref="projectMessage"></project-message-logger>
        </vs-popup>
        
        <!-- SUPPLIER INFORMATION -->
        <vs-popup title="Información del Proveedor" :active.sync="showFormPromptSupplierInfo">
            <supplier-details v-if="currentSupplierID !== null" ref="supplierDetails" :supplier_id="currentSupplierID"></supplier-details>
        </vs-popup>

         <!-- INFORMACIÓN DE PROGRAMA -->
         <vs-popup v-if="currentLead" class="mid-popup header-primary" title="Detalle del lead de programa" :active.sync="popupActivoProgram">
            <vx-card>
                <h3>Información</h3>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p class="bold">Cliente: </p> <span>{{ currentLead.customer_uid }} | {{ currentLead.customer_name }}</span> <br>
                        <p class="bold">Zona | Región: </p> <span> {{ getZone(currentLead) }} | {{ getRegion(currentLead) }}</span> <br>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
import CreditEventsLog from "@components/projectsv2/CreditEventsLog";
import ProjectMessageLogger from "../../../components/ProjectMessageLogger";
import SupplierDetails from "./process-flow/SupplierDetails";
import SupplierAgentInformation from "@projects/SupplierAgentInformation";
import ProjectArchiveButton from "../../../components/project-details/ProjectArchiveButton";
import LoanScreenedButton from "../../../components/project-details/LoanScreenedButton.vue";

const columns = [
    { title: "PID | ALIAS", key: "pid", sortable: true }
    , { title: "ESTATUS DE PROYECTO", key: "status", sortable: true }
    , { title: "SOLICITANTE", key: "client", sortable: false }
    , { title: "EJECUTIVO DE ORIGINACIÓN", key: "origination_responsible", sortable: true }
    , { title: "EJECUTIVO DE RIESGO", key: "credit_risk_responsible", sortable: true }
    , { title: "INSTALADOR", key: "supplier", sortable: false }
    , { title: "NO. DE REBOTES", key: "days", sortable: true }
    , { title: "DÍAS TRANSCURRIDOS", key: "days", sortable: true }
    , { title: "ACCIONES", key: "actions", sortable: true }
];

export default {
    name: "ProjectsLeadPreApproved",
    mixins: [formatHelper],
    components: {
        CreditEventsLog,
        ProjectMessageLogger,
        SupplierDetails,
        SupplierAgentInformation,
        ProjectArchiveButton,
        LoanScreenedButton
    },
    data() {
        return {
            search: "",
            searching: false,
            projects: [],
            columns: columns,
            showFormPromptCreditEvents: false,
            showFormPromptMessages: false,
            showFormPromptSupplierInfo: false,
            currentProjectId: null,
            currentSupplierID: null           
            , popupActivoProgram: false
            , currentLead: null
        }
    },
    mounted(){
        this.getProjectsList();
    },
    methods: {
        async getProjectsList(){
            this.showLoading(true);
            try {
                const res = await axios.post('/api/projects/follow-up', {
                    "search": this.search
                });
    
                this.projects = res.data;
                
            } catch (error) {
               this.warn(error); 
            }
            this.showLoading(false);
        },
        showCreditEvents(pid){
            this.currentProjectId = pid;
            this.showFormPromptCreditEvents = true;
            this.$refs.creditEvents.getEvents(pid);
        },
        showProjectMessages(pid){
            this.showFormPromptMessages = true;
            this.$refs.projectMessage.setProjectId(pid);
            this.$refs.projectMessage.getNotes(pid);
        },
        showSupplierInformation(sid){
            this.currentSupplierID = sid;
            this.showFormPromptSupplierInfo = true;
            this.$refs.supplierDetails.update(sid);
            this.$refs.supplierDetails.getSupplierAgents(sid);

        },
        setProjectInformation(item){
            return {
                id: item.PID
                , status: item.real_status
                , resolution_date: item.resolution_date
            }
        },
        getZone(pgmApplicant) {
            if(pgmApplicant.subregion_manager_id !== null 
                && pgmApplicant.subregion_manager.region_manager_id !== null
                && pgmApplicant.subregion_manager.region_manager.zone_manager_id !== null
                && pgmApplicant.subregion_manager.region_manager.region !== null
                && pgmApplicant.subregion_manager.region_manager.region.zone !== null
                ){
                    return pgmApplicant.subregion_manager.region_manager.region.zone.name;
            }
        },
        getRegion(pgmApplicant) {
            if(pgmApplicant.subregion_manager_id !== null 
                && pgmApplicant.subregion_manager.region_manager_id !== null
                && pgmApplicant.subregion_manager.region_manager.region !== null
                ){
                    return pgmApplicant.subregion_manager.region_manager.region.name;
            }
        },
    }
    

}
</script>

<style>

.clickable {
    cursor: pointer !important;
}

.vs-table--tbody {
    z-index: 9 !important;
}
</style>